<side-panel-header [title]="'Get started' | translate" />
<side-panel-content class="p-md">
  <sb-checklist-progress-heading [title]="title()" [titleSize]="'xl'" [progress]="progress()" />

  <sb-checklist-content [items]="items()" class="mt-5">
    @if (showFooter()) {
      <book-a-call-footer sb-checklist-footer [originator]="'dashboard'" />
    }
  </sb-checklist-content>

  <button sb-button class="self-end font-bold" [color]="'transparent'" [size]="'sm'" (click)="dismissChecklist()">
    {{ 'Dismiss checklist' | translate }}
  </button>
</side-panel-content>
